import { Injectable } from '@angular/core';
import { Observable, from, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { BarcodeCorrectionLogControllerService } from '../../../../api/stock-service/api/barcodeCorrectionLogController.service';
import {
  BarcodeCorrectionLog,
  BarcodeCorrectionLogSearchDTO,
} from '../../../../api/stock-service/model/models';
import { BlobConverterUtil } from '@app/shared/utils/blob-converter.util';

export interface BarcodeCorrectionsSearchParams {
  scannedBarcode?: string;
  skuCode?: string;
  warehouseWarrantCode?: string;
  status?: string;
  createdBy?: string;
  fromDate?: string;
  toDate?: string;
  page: number;
  size: number;
}

@Injectable({
  providedIn: 'root',
})
export class BarcodeCorrectionsService {
  constructor(
    private readonly barcodeCorrectionLogControllerService: BarcodeCorrectionLogControllerService,
  ) {}

  getBarcodeCorrections(
    params: BarcodeCorrectionsSearchParams,
  ): Observable<{ data: BarcodeCorrectionLog[]; total: number }> {
    const searchDTO: BarcodeCorrectionLogSearchDTO = {
      scannedBarcode: params.scannedBarcode || undefined,
      skuCode: params.skuCode || undefined,
      warehouseWarrantCode: params.warehouseWarrantCode || undefined,
      status: params.status || undefined,
      createdBy: params.createdBy || undefined,
      fromDate: params.fromDate || undefined,
      toDate: params.toDate || undefined,
      page: params.page,
      size: params.size,
      sortBy: 'creationDate',
      ascending: false,
    };

    return this.barcodeCorrectionLogControllerService.page(searchDTO).pipe(
      // The generated client picks 'blob' as the response type whenever the
      // effective Accept header is '*/*' (default when no options are passed),
      // since that doesn't match its own JSON-mime check — same quirk worked
      // around elsewhere in this app via BlobConverterUtil.
      switchMap((response: any) => from(BlobConverterUtil.convertToJson(response))),
      map((response) => ({
        data: response?.pageContent || [],
        total: response?.totalElements || 0,
      })),
      catchError((error) => {
        console.error('Error fetching barcode correction logs:', error);
        return of({ data: [], total: 0 });
      }),
    );
  }
}
